import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Auth0TokenService } from 'projects/api/src/services/auth0-token/auth0-token.service';
import { TokenService } from '../services/token/token.service';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
	constructor(
		private readonly tokenService: TokenService,
		private readonly auth0TokenService: Auth0TokenService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const auth0AccessToken = this.auth0TokenService.accessToken;
		const auth0IdToken = this.auth0TokenService.idToken;

		if (auth0AccessToken && auth0IdToken) {
			const auth0HeaderRequest = req.clone({
				setHeaders: {
					'X-Id-Token': auth0IdToken,
					Authorization: `Bearer ${auth0AccessToken}`,
					Source: 'web',
					'If-Modified-Since': 'Wed, 16 Jul 1997 12:00:00 GMT',
					'Cache-Control': 'no-cache',
					Pragma: 'no-cache'
				}
			});

			return next.handle(auth0HeaderRequest);
		}

		const edassistTokenRequest = req.clone({
			setHeaders: {
				'X-AUTH-TOKEN': this.tokenService.token ?? '',
				Source: 'web',
				'If-Modified-Since': 'Wed, 16 Jul 1997 12:00:00 GMT',
				'Cache-Control': 'no-cache',
				Pragma: 'no-cache'
			}
		});

		return next.handle(edassistTokenRequest);
	}
}
